import React, { useMemo } from "react"

import { PrimaryText } from "@front-shared/elements/primaryText.element"

import { COVERAGE_CONFIG } from "../../../config/coverage.config"
import { useAppSelector } from "../../../store/selectors/app.selector"
import { checkerSelector } from "../../../store/selectors/checker.selector"
import { userDetailsSelector } from "../../../store/selectors/userDetails.selector"

import creditsIcon from "@front-shared/assets/images/icons/credits-dark.svg"

export const CheckerCreditsIndicatorComponent: React.FunctionComponent<
    ICheckerCreditsIndicatorComponentProps
> = props => {
    const { manualCheckType } = useAppSelector(checkerSelector)
    const { selectedPracticeUsageQuota } = useAppSelector(userDetailsSelector)

    const creditsAmount = useMemo(() => {
        if (
            !manualCheckType ||
            !selectedPracticeUsageQuota ||
            COVERAGE_CONFIG.usageQuota.ignoredTypes.includes(manualCheckType)
        ) {
            return 0
        }

        return (
            ((props.inNetworkCheckEnabled ? 1 : 0) +
                (props.outNetworkCheckEnabled ? 1 : 0)) *
            selectedPracticeUsageQuota.checkTypeCreditsAmount[manualCheckType]
        )
    }, [
        manualCheckType,
        selectedPracticeUsageQuota,
        props.inNetworkCheckEnabled,
        props.outNetworkCheckEnabled,
    ])

    return (
        <div
            className={`
                relative flex items-center gap-[8px]
                ${props.className}
            `}
        >
            {creditsAmount ? (
                <>
                    <img src={creditsIcon} alt="credits" />

                    <PrimaryText typography="caption">Credits used</PrimaryText>

                    <PrimaryText typography="buttonText" weight="medium">
                        {creditsAmount}
                    </PrimaryText>
                </>
            ) : null}
        </div>
    )
}

interface ICheckerCreditsIndicatorComponentProps {
    className?: string
    inNetworkCheckEnabled?: boolean
    outNetworkCheckEnabled?: boolean
}
